// extracted by mini-css-extract-plugin
module.exports = {"container":"GrowYourProjectSection_container__00b_g","title":"GrowYourProjectSection_title__J0N6x","text":"GrowYourProjectSection_text__PoiAf"};